import React from 'react';
import { Dialog, DialogContent, Grid } from '@material-ui/core';
import parse from 'html-react-parser';

interface Props {
  open: boolean;
  loader: boolean;
  content: JSX.Element | string;
  submitText?: string;
  handleClick: (_flag: boolean) => void;
}

const ConfirmationDialog: React.FC<Props> = ({
  open,
  loader,
  content,
  submitText,
  handleClick,
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => handleClick(false)}
      aria-labelledby="responsive-dialog-title"
      maxWidth="xs"
      fullWidth={true}
      id="successModal"
      className={`brand-confirmation-dialog`}
      data-testid="confirmationDialog"
    >
      <DialogContent
        className={`brand-confirmation-dialog-content text-center`}
      >
        <Grid container>
          <Grid item xs={12} className="title">
            <p className="paragraph" data-testid="confirmationDialogContent">
              {typeof content === 'string' ? parse(content) : content}
            </p>
          </Grid>
          <Grid item xs={12} className="footer">
            <li>
              <p>
                <a
                  className={'secondary-btn'}
                  onClick={() => handleClick(false)}
                  data-testid="confirmationDialogCancelButton"
                >
                  Cancel
                </a>
              </p>
            </li>
            <li>
              <p>
                <a
                  className={loader ? 'primary-btn disabled' : 'primary-btn'}
                  onClick={() => handleClick(true)}
                  data-testid="confirmationDialogSubmitButton"
                >
                  {loader
                    ? 'Processing...'
                    : submitText
                    ? submitText
                    : 'I Agree'}
                </a>
              </p>
            </li>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
export default ConfirmationDialog;
